import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="episode-watch-button"
export default class extends Controller {
  static targets = ["button", "checkIcon", "emptyIcon", "spinner"];
  static values = { episodeId: Number };

  connect() {
    // Listen for turbo:submit-start and turbo:submit-end events
    this.element.addEventListener(
      "turbo:submit-start",
      this.showLoading.bind(this)
    );
    this.element.addEventListener(
      "turbo:submit-end",
      this.hideLoading.bind(this)
    );
  }

  disconnect() {
    this.element.removeEventListener(
      "turbo:submit-start",
      this.showLoading.bind(this)
    );
    this.element.removeEventListener(
      "turbo:submit-end",
      this.hideLoading.bind(this)
    );
  }

  handleClick(event) {
    // The form submission will trigger turbo:submit-start automatically
    // This method can be used for additional click handling if needed
  }

  showLoading() {
    // Hide the current icon and show spinner
    if (this.hasCheckIconTarget) {
      this.checkIconTarget.classList.add("hidden");
    }
    if (this.hasEmptyIconTarget) {
      this.emptyIconTarget.classList.add("hidden");
    }
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.remove("hidden");
    }

    // Disable the button to prevent multiple clicks
    this.buttonTarget.disabled = true;
    this.buttonTarget.classList.add("cursor-not-allowed");
    this.buttonTarget.classList.remove("cursor-pointer");
  }

  hideLoading() {
    // This will be called when the turbo request completes
    // But since the entire element gets replaced by turbo stream,
    // we don't need to manually hide the spinner - the new state will render

    // Reset button state in case the request fails
    if (this.hasButtonTarget) {
      this.buttonTarget.disabled = false;
      this.buttonTarget.classList.remove("cursor-not-allowed");
      this.buttonTarget.classList.add("cursor-pointer");
    }
  }
}
